import { SocialDisconnectModal, SocialDisconnectModalProps } from '@minecraft.organisms';
import React from 'react';
import { useTranslation } from '@blocs.i18n';

interface UnifiedDisconnectModalProps {
  platform: 'Instagram' | 'YouTube';
  deleteAllSocialData: () => Promise<void>;
  disconnectSocialAccount: () => Promise<void>;
  mutationLoading: boolean;
  close: () => void;
  'data-testid'?: string;
}

export const UnifiedDisconnectModal = ({
  platform,
  deleteAllSocialData,
  disconnectSocialAccount,
  mutationLoading,
  close,
  'data-testid': dataTestId,
}: UnifiedDisconnectModalProps) => {
  const { t } = useTranslation();

  const modalButtons: SocialDisconnectModalProps['buttonsConfig'] = [
    {
      label: t('common:button.cancel'),
      onClick: close,
      variant: 'secondary',
    },
    {
      label: t('common:profileEdit.social.disconnectModal.button.disconnectAllProfiles'),
      onClick: async () => {
        await deleteAllSocialData();
        close();
      },
      disabled: mutationLoading,
    },
    {
      label: t('common:profileEdit.social.disconnectModal.button.disconnectThisProfile'),
      onClick: async () => {
        await disconnectSocialAccount();
        close();
      },
      disabled: mutationLoading,
    },
  ];

  return (
    <SocialDisconnectModal
      isOpen
      close={close}
      buttonsConfig={modalButtons}
      data-testid={dataTestId}
      title={t('common:profileEdit.social.disconnectModal.title', {
        socialMediaPlatform: platform,
      })}
      headerText={t('common:profileEdit.social.disconnectModal.headerText', {
        socialMediaPlatform: platform,
      })}
      disconnectProfileHeader={t('common:profileEdit.social.disconnectModal.disconnectThisProfile.header')}
      disconnectProfileDescription={t('common:profileEdit.social.disconnectModal.disconnectThisProfile.description', {
        socialMediaPlatform: platform,
      })}
      disconnectAllHeader={t('common:profileEdit.social.disconnectModal.disconnectAllProfiles.header')}
      disconnectAllDescription={t('common:profileEdit.social.disconnectModal.disconnectAllProfiles.description', {
        socialMediaPlatform: platform,
      })}
    />
  );
};
